var _path, _path2, _line, _circle, _circle2, _line2, _line3, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockupStacked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 300",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SuqPOS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    x: 60,
    y: 0,
    width: 200,
    height: 178,
    viewBox: "210 62 180 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#32D4E0",
    strokeWidth: 7,
    strokeLinecap: "round",
    d: "M 240 210 L 240 140 Q 240 80 300 80 Q 360 80 360 140 L 360 210"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFB340",
    strokeWidth: 7,
    strokeLinecap: "round",
    d: "M 258 210 L 258 148 Q 258 108 300 108 Q 342 108 342 148 L 342 210"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 228,
    y1: 210,
    x2: 372,
    y2: 210,
    stroke: "#32D4E0",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 80,
    r: 7,
    fill: "#32D4E0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 108,
    r: 5,
    fill: "#FFB340"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 228,
    y1: 175,
    x2: 248,
    y2: 175,
    stroke: "#32D4E0",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    opacity: 0.4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 352,
    y1: 175,
    x2: 372,
    y2: 175,
    stroke: "#32D4E0",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    opacity: 0.4
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 228,
    textAnchor: "middle",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Inter', sans-serif",
    fontSize: 52,
    letterSpacing: -1.5
  }, /*#__PURE__*/React.createElement("tspan", {
    fontWeight: 700,
    fill: "#32D4E0"
  }, "Suq"), /*#__PURE__*/React.createElement("tspan", {
    fontWeight: 600,
    fill: "#FFB340",
    letterSpacing: -1
  }, "POS"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 258,
    textAnchor: "middle",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Inter', sans-serif",
    fontSize: 13,
    fontWeight: 500,
    letterSpacing: 2.5,
    fill: "#98989F"
  }, "SMART SALES \xB7 ANYWHERE")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockupStacked);
export default __webpack_public_path__ + "static/media/lockup-stacked.f72130590988a09b36e2e82e444e570b.svg";
export { ForwardRef as ReactComponent };